import Flyer from "../../../../components/flyer"
import FLYER_ACCEPTANCE_ONE from './img/FLYER_ACCEPTANCE_ONE.png'
import FLYER_ACCEPTANCE_TWO from './img/FLYER_ACCEPTANCE_TWO.png'
import FLYER_ACCEPTANCE_ONE_SP from './img/FLYER_ACCEPTANCE_ONE_SP.png'
import FLYER_ACCEPTANCE_TWO_SP from './img/FLYER_ACCEPTANCE_TWO_SP.png'
interface Props {
  id_campaign: string
  id_employee: string
}
const FlyerAcceptance = ({ id_campaign, id_employee }: Props) => {
  return (
    <>
      <div className="c-flyers">
        <Flyer
          url='/api/purls/employee/campaigns/flyer/en/one'
          url_bw='/api/purls/employee/campaigns/flyer/en/one-bw'
          title='QR Code Flyer  English'
          id_campaign={id_campaign}
          id_employee={id_employee}
          name='flyer-color'
          name_bw='flyer-bw'
          image={FLYER_ACCEPTANCE_ONE}
        />
        <Flyer
          url='/api/purls/employee/campaigns/flyer/en/two'
          url_bw='/api/purls/employee/campaigns/flyer/en/two-bw'
          title='QR Code Flyer Two English'
          id_campaign={id_campaign}
          id_employee={id_employee}
          name='flyer-two-color'
          name_bw='flyer-two-bw'
          image={FLYER_ACCEPTANCE_TWO}
        />
      </div>
      <div className="c-flyers">
        <Flyer
          url='/api/purls/employee/campaigns/flyer/es/one'
          url_bw='/api/purls/employee/campaigns/flyer/es/one-bw'
          title='QR Code Flyer Spanish'
          id_campaign={id_campaign}
          id_employee={id_employee}
          name='flyer-es-color'
          name_bw='flyer-es-bw'
          image={FLYER_ACCEPTANCE_ONE_SP}
        />
        <Flyer
          url='/api/purls/employee/campaigns/flyer/es/two'
          url_bw='/api/purls/employee/campaigns/flyer/es/two-bw'
          title='QR Code Flyer Two Spanish'
          id_campaign={id_campaign}
          id_employee={id_employee}
          name='flyer-es-two-color'
          name_bw='flyer-es-two-bw'
          image={FLYER_ACCEPTANCE_TWO_SP}
        />
      </div>
    </>
  )
}

export default FlyerAcceptance